export enum ShippingContextList {
    STOCK_LOCATOR = "StockLocator",
    SHIPPING_LAYER = "ShippingLayer",
    PRODUCT_SHEET = "ProductSheet",
    BUNDLE_PRODUCT_SHEET = "BundleProductSheet",
    ATTACHMENT_LAYER = "AttachmentLayer",
  }